module.exports = __webpack_public_path__ + "pc/img/footer.7a6daa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer.png
// module id = FBBW
// module chunks = 5